import graphql__8fdd30aa9afd6921ebd1 from "./__generated__/ContributionFormModalTitle_contribution.graphql.js";import { useState, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import Icon from "../Utils/Icon";

import Button from "../Buttons/Button";
import { Desktop } from "../Utils/ResponsiveQueries";
import { useFormatMessage } from "../Intl/Context";

import { contributionFormStepBack } from "../../mutations/ContributionFormStepBackMutation";
import { isAuthorized } from "../Utils/authorizations";

const ContributionFormModalTitle = props => {
  const contribution = useFragment(
    ContributionFormModalTitle_contribution,
    props.contribution
  );
  const { stepIndex, stepsTotal, hasPreviousPage } = contribution;
  const { title } = props;

  const allowFormStepBack = isAuthorized(contribution.authorizations.formStepBack);
  const allowDisplayStepsProgression = isAuthorized(
    contribution.authorizations.displayStepsProgression
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  const t = useFormatMessage();
  const stepName = t(intlMessages.stepName, {
    stepIndex: stepIndex + 1,
    stepsTotal: stepsTotal
  });
  const stepBack = t(intlMessages.stepBack);
  const backButtonSrOnlyLabel = t(intlMessages.backButtonSrOnlyLabel);

  const isDisabled = isSubmitting || !allowFormStepBack;

  const handleBackButtonClicked = useCallback(() => {
    setIsSubmitting(true);
    contributionFormStepBack(contribution);
  }, [contribution]);

  const displayStepBackButton = allowDisplayStepsProgression || hasPreviousPage;
  const backButtonLabel = allowDisplayStepsProgression ? stepName : stepBack;

  return (
    <Desktop>
      <div className="modal-form-title margin-bottom-xs box d-flex flex-row">
        {displayStepBackButton && (
          <Button
            type="button"
            className="btn btn-primary-inverse step-button text-legend d-flex flex-column justify-content-center"
            onClick={handleBackButtonClicked}
            disabled={isDisabled}
            data-loading={isSubmitting}
            innerClassName="d-flex justify-content-center"
          >
            <span className="d-flex button-inner align-items-center">
              {stepIndex > 0 && (
                <Icon
                  style={{ marginBottom: 2 }}
                  className="fa fa-chevron-left d-block text-small"
                />
              )}
              <span>
                {backButtonLabel}

                {allowFormStepBack && (
                  <span className="sr-only">{backButtonSrOnlyLabel}</span>
                )}
              </span>
            </span>
          </Button>
        )}

        <h1 className="modal-form-title-text padding-md text-title-page">{title}</h1>
      </div>
    </Desktop>
  );
};

const ContributionFormModalTitle_contribution = graphql__8fdd30aa9afd6921ebd1;

export default ContributionFormModalTitle;

const intlMessages = defineMessages({
  stepBack: {
    id: "contribution.form.header.stepBack",
    defaultMessage: "Retour"
  },
  stepName: {
    id: "contribution.form.header.stepName",
    defaultMessage: "Étape {stepIndex} / {stepsTotal}"
  },
  backButtonSrOnlyLabel: {
    id: "contribution.form.header.backButtonSrOnlyLabel",
    defaultMessage: "Retour à l'étape précédente"
  }
});
